export const SET_COMMUNICATION_TOGGLE = 'SET_COMMUNICATION_TOGGLE';
export const setCommunicationToggle = header => ({
  type: SET_COMMUNICATION_TOGGLE,
  payload: header,
});
